<template>
  <ElDialog
    class="ad-contract-pending"
    :title="$t('ADVERTISEMENT.CONTRACT.TITLE')"
    :visible="value"
    :close-on-click-modal="!isLoadingAcceptance"
    :close-on-press-escape="!isLoadingAcceptance"
    :show-close="!isLoadingAcceptance"
    width="830px"
    @close="close"
  >
    <div v-if="isLoadingContract" class="ad-contract-pending__loading-wrapper">
      <HollowDotsSpinner
        :animation-duration="1000"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
      />
    </div>
    <div v-else>
      <p class="ad-contract-pending__due-date-desc">
        <i18n path="ADVERTISEMENT.CONTRACT.DUE_DATE_DESCRIPTION">
          <strong place="date">{{ contract.dueDate }}</strong>
        </i18n>
      </p>
      <AdContractContent :contract="contractTemplate" />
    </div>

    <div slot="footer" class="ad-contract-pending__actions">
      <a
        :disabled="isLoadingContract"
        class="link"
        target="_blank"
        download
        :href="contractPDF"
      >
        <i class="el-icon-download" />
        {{ $t('ADVERTISEMENT.CONTRACT.DOWNLOAD') }}
      </a>
      <ElButton
        :disabled="isLoadingContract"
        :loading="isLoadingAcceptance"
        type="primary"
        @click.native.prevent="acceptContract"
      >
        {{ $t('ADVERTISEMENT.CONTRACT.ACTION') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import AdContractContent from './common/AdContractContent';
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';
import { AdContract } from '@/api/api';
import capitalize from '@/utils/capitalize';
import lang from '@/mixins/lang';
import { mapActions } from 'vuex';
import { ACCEPT_AD_CONTRACT } from '@/store/types';

export default {
  name: 'AdContract',
  components: {
    AdContractContent,
    HollowDotsSpinner,
  },
  mixins: [lang],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoadingContract: true,
      contract: null,

      isLoadingAcceptance: false,
    };
  },
  computed: {
    campitalizedLang() {
      return capitalize(this.normalizedLang);
    },
    contractTemplate() {
      return this.contract[`html${this.campitalizedLang}`];
    },
    contractPDF() {
      if (!this.contract) return '#';

      return this.contract[`downloadLink${this.campitalizedLang}`];
    },
  },
  mounted() {
    this.getContract();
  },
  methods: {
    ...mapActions({
      acceptStoreAdContract: ACCEPT_AD_CONTRACT,
    }),
    close() {
      this.$emit('input', false);
    },
    getContract() {
      this.isLoadingContract = true;
      return AdContract.getContract()
        .then(contract => {
          this.contract = contract;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoadingContract = false;
        });
    },
    acceptContract() {
      this.isLoadingAcceptance = true;
      return AdContract.acceptContract()
        .then(({ message }) => {
          this.$message.success(message);

          this.acceptStoreAdContract();

          this.close();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoadingAcceptance = false;
        });
    },
  },
};
</script>

<style lang="scss">
.ad-contract-pending {
  &__loading-wrapper {
    display: flex;
    justify-content: center;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__due-date-desc {
    margin-bottom: $global-margin * 2;
  }
}
</style>
